import { CriteriaAggregateType, CriteriaTokenType, } from '../../../types';
import guardNumber from '../../../utils/guardNumber';
export default function aggregateCriteriaToFilterDto(criteria) {
    var _a, _b;
    switch (criteria === null || criteria === void 0 ? void 0 : criteria.type) {
        case CriteriaAggregateType.NUM_ROWS:
            return {
                type: 'Aggregate',
                property: CriteriaTokenType.NUM_ROWS,
                condition: (_a = criteria.operator) !== null && _a !== void 0 ? _a : 'GREATER_THAN_EQUAL',
                amount: guardNumber(criteria.amount, 0),
            };
        case CriteriaAggregateType.TOTAL_AMOUNT:
            return {
                type: 'Aggregate',
                property: CriteriaTokenType.TOTAL_AMOUNT,
                condition: (_b = criteria.operator) !== null && _b !== void 0 ? _b : 'GREATER_THAN_EQUAL',
                amount: guardNumber(criteria.amountCurrency, 0, function (value) { return value * 100; }),
            };
        default:
            return undefined;
    }
}
